import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../api';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      toast.error('Authentication cancelled');
      setTimeout(() => navigate('/'), 2000);
      return;
    }

    if (!code) {
      toast.error('No authorization code received');
      setTimeout(() => navigate('/'), 2000);
      return;
    }

    authAPI
      .handleCallback(code)
      .then((response) => {
        localStorage.setItem('gty_token', response.data.token);
        const name = response.data.user.display_name || response.data.user.username;
        toast.success(`Welcome, ${name}!`);
        if (response.data.no_server_nick) {
          setTimeout(() => {
            toast.warning(
              'Nemáš nastavenou přezdívku na GTY Discord serveru — tvoje jméno je nastaveno na Discord username. Nastav si server nickname a přihlas se znovu.',
              { duration: 10000 }
            );
          }, 800);
        }
        setTimeout(() => {
          setIsProcessing(false);
          navigate('/dashboard', { replace: true });
        }, 500);
      })
      .catch((err) => {
        const errorMsg = err.response?.data?.detail || 'Authentication failed';
        toast.error(errorMsg);
        setTimeout(() => navigate('/'), 2000);
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="auth-callback-page">
      <div className="text-center">
        {isProcessing && (
          <div>
            <Loader2 className="w-16 h-16 animate-spin text-purple-500 mx-auto mb-6" />
            <p className="text-[#a1a1aa] text-lg uppercase tracking-wider">Authenticating...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;